import { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router'

import { useAuth } from './AuthContext'
import { canOpen, isAdminRole, landingFor } from './nav'

/**
 * Gate for the admin tree. Renders the nested routes when authenticated;
 * otherwise redirects to the login screen with a `next` param so the user
 * returns to where they were after signing in. `replace` keeps the
 * protected URL out of history, so Back doesn't bounce through it post-logout.
 *
 * Being signed in is not enough (M36-T03). The admin admits an explicit list
 * of roles; any other is signed out, never treated as a hospital admin. And
 * `support` may open only its own pages, so anything else sends it to its
 * landing page.
 */
export function ProtectedRoute() {
  const { user, logout } = useAuth()
  const location = useLocation()
  const refused = user !== null && !isAdminRole(user.role)

  useEffect(() => {
    if (refused) logout('role_not_permitted')
  }, [refused, logout])

  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/admin/login?next=${next}`} replace />
  }
  if (!isAdminRole(user.role)) return null
  if (!canOpen(user.role, location.pathname)) {
    return <Navigate to={landingFor(user.role)} replace />
  }
  return <Outlet />
}
